module.exports = __webpack_public_path__ + "static/media/Poster V6.fa66a40d.jpg";